import { render, staticRenderFns } from "./cross-fade-slider.vue?vue&type=template&id=0393fb4a&scoped=true"
import script from "./cross-fade-slider.vue?vue&type=script&lang=js"
export * from "./cross-fade-slider.vue?vue&type=script&lang=js"
import style0 from "./cross-fade-slider.vue?vue&type=style&index=0&id=0393fb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393fb4a",
  null
  
)

export default component.exports